$(document).on("click", "#device-license", function () {
  let deviceLicense = $(this).data('device-license')
  navigator.clipboard.writeText(deviceLicense)
  this.innerText = "License copied to clipboard!"
})

$(document).on("click", ".copy-to-clipboard", function () {
  navigator.clipboard.writeText($(this).data('copy'))
  $(this).addClass('copied')
  setTimeout(() => $(this).removeClass('copied'), 1500)
})
